import applyAriaHiddenToImg from './utils/apply-aria-hidden-to-img.js';
import applyAriaLabelledbytoLink from './utils/apply-aria-labelledby-to-link.js';

export default function decorate(block) {
  applyAriaHiddenToImg(block);
  applyAriaLabelledbytoLink(block);
}
